import React, { useEffect, useState } from 'react';
import { Table, Spin } from 'antd';
import { poblaciondesagregada } from '../../../services/perfiles/conponentesServices';

const columns = [
  {
    title: 'Tipo de Población',
    dataIndex: 'tipo',
    key: 'tipo',
  },
  {
    title: 'Cantidad',
    dataIndex: 'cantidad',
    key: 'cantidad',
  },
  {
    title: 'Porcentaje',
    dataIndex: 'porcentaje',
    key: 'porcentaje',
  },
];

const PoblationTD = ({ municipioId }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fuente, setFuente] = useState('');
  const [vigencia, setVigencia] = useState('');

  useEffect(() => {
    if (municipioId) {
          fetchData();
    }

  }, [municipioId]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await poblaciondesagregada(municipioId);
  
      // Asegúrate de acceder a la primera entrada de la respuesta
      const poblacionData = response.data[0]; // Asegúrate de que es un array
      const { pobl_urbana, porc_urbana, pobl_rural, porc_rural, pobl_total, porc_total, fuente, vigencia } = poblacionData;

      setData([
        {
          key: '1',
          tipo: 'POB. URBANA',
          cantidad: pobl_urbana.toLocaleString(),
          porcentaje: `${porc_urbana}%`,
        },
        {
          key: '2',
          tipo: 'POB. RURAL',
          cantidad: pobl_rural.toLocaleString(),
          porcentaje: `${porc_rural}%`,
        },
        {
          key: '3',
          tipo: 'POBLACIÓN TOTAL',
          cantidad: pobl_total.toLocaleString(),
          porcentaje: `${porc_total}%`,
        },
      ]);
      setFuente(fuente);
      setVigencia(vigencia);
      setLoading(false);
    } catch (error) {
      console.error('Error obteniendo las áreas', error);
      setLoading(false);
    }
  };

  if (loading) {
    return <Spin />;
  }

  return (
    <Table
      columns={columns}
      dataSource={data}
      pagination={false}
      bordered
      title={() => `Población desagregada por área - ${new Date().getFullYear()}`}
      footer={() => fuente}
    />
  );
};

export default PoblationTD;
